import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import { PlayerError } from '@dtvgo/player-common-utils';

/**
 * @enum {'LL-HD' | 'SD-HD'}
 * @readonly
 */
var DrmQuality = {
  LOW_LATENCY: 'LL-HD',
  DEFAULT: 'SD-HD'
};
var isLicenseError = function isLicenseError(error) {
  return error.code === PlayerError.Code.LICENSE_REQUEST_FAILED;
};

/**
 * Removes periods without audio from the given DASH manifest XML.
 *
 * @param {XMLDocument} dashManifestXML - The DASH manifest XML.
 * @return {XMLDocument} The updated DASH manifest XML with periods without audio removed.
 */
function removePeriodsWithoutAudio(dashManifestXML) {
  var _iterator = _createForOfIteratorHelper(dashManifestXML.querySelectorAll('Period')),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var period = _step.value;
      if (period.querySelectorAll('AdaptationSet[mimeType="audio/mp4"],AdaptationSet[contentType="audio"]').length === 0) {
        period.remove();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return dashManifestXML;
}

/**
 * @typedef {{ [key: string]: T }} ObjectOf
 * @template T
 */

/**
 * @callback GetHeadersCallback
 * @returns {Promise<ObjectOf<string>>}
 */

export { DrmQuality, isLicenseError, removePeriodsWithoutAudio };
//# sourceMappingURL=utils.js.map
